export default {
  modals: {
    delete_payment_method: {
      title: 'Are you sure you want to remove this payment method?',
    },
  },
  buttons: {
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  toasts: {
    failed_to_delete_payment_method: 'Failed to delete payment method',
    payment_method_deleted: 'Payment method got deleted',
  },
};
